import React from 'react';
import BackgroundCover from '../../components/backgroundCover/BackgroundCover';
import { useLanguage } from '../../context/LanguageContext';
import { imprintTemplateTranslations } from '../../translations/imprintTemplate';

function Imprint() {
    const { language } = useLanguage();
    const t = imprintTemplateTranslations[language];

    return (
        <div className="">
            <BackgroundCover
                backgroundHeight={300}
                imagePosition="initial"
                backgroundImage="/images/clockwork_light_background.png"
            >
                <div className="absolute top-1/2 left-[10%] -translate-y-1/2 z-10 hidden md:block">
                    <h1 className="text-4xl font-bold text-white">{t.pageTitle}</h1>
                </div>
            </BackgroundCover>

            <div className="mx-auto px-4 md:px-0 py-12 md:py-24">
                <div className="block md:hidden mb-8">
                    <h1 className="text-4xl font-bold">{t.pageTitle}</h1>
                </div>

                <div className="flex flex-col items-center">
                    <div className="max-w-4xl">
                        <section className="mb-8">
                            <p className="font-semibold">Realization Desal AG</p>
                            <p>Steinibachstrasse 3</p>
                            <p>6317 Oberwil b. Zug</p>
                            <p>{language === 'de' ? 'Schweiz' : 'Switzerland'}</p>
                        </section>

                        <section className="mb-8">
                            <p><span className="font-semibold">{t.phone}:</span> +41 415252533</p>
                            <p><span className="font-semibold">{t.email}:</span> contact@niveau-eleve.ch</p>
                        </section>

                        <section className="mb-12">
                            <h2 className="text-2xl font-bold mb-4">{t.authorizedRepresentatives}</h2>
                            <p><span className="font-semibold">{t.boardOfDirectors}:</span> Michael Bonke</p>
                        </section>

                        <section className="mb-12">
                            <h2 className="text-2xl font-bold mb-4">{t.registerEntry}</h2>
                            <p><span className="font-semibold">{t.registeredCompanyName}:</span> Realization Desal AG</p>
                            <p><span className="font-semibold">{t.companyNo}:</span> CHE-406.044.624</p>
                            <p><span className="font-semibold">{t.vatNumber}:</span> CHE-406.044.624 MWST</p>
                            <p><span className="font-semibold">{t.registerNumber}:</span> CH-170.3.040.454-4</p>
                        </section>

                        <section className="mb-12">
                            <h2 className="text-2xl font-bold mb-4">{t.disclaimer}</h2>
                            <div className="text-base text-gray-600 leading-relaxed space-y-4">
                                {t.disclaimerText.map((text, index) => (
                                    <p key={index}>{text}</p>
                                ))}
                            </div>
                        </section>

                        <section className="mb-12">
                            <h2 className="text-2xl font-bold mb-4">{t.disclaimerForLinks}</h2>
                            <p className="text-base text-gray-600 leading-relaxed">
                                {t.disclaimerForLinksText}
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold mb-4">{t.copyright}</h2>
                            <p className="text-base text-gray-600 leading-relaxed">
                                {t.copyrightText}
                            </p>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Imprint; 